/* PAVEMOM — advanced cart drawer */
(function () {
  'use strict';
  var SECTION_ID = 'cart-drawer';
  var drawer = document.querySelector('[data-cart-drawer]');
  if (!drawer) return;
  var panel = drawer.querySelector('.cd__panel');
  var lastFocus = null;

  function qsa(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }

  function open() {
    lastFocus = document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('drawer-open');
    var c = drawer.querySelector('.cd__close'); if (c) c.focus();
  }
  function close() {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('drawer-open');
    if (lastFocus) lastFocus.focus();
  }

  qsa('[data-cart-open], a[href$="/cart"], a[href="/cart"]').forEach(function (el) {
    el.addEventListener('click', function (e) {
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.button) return;
      e.preventDefault(); open();
    });
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && drawer.classList.contains('is-open')) close(); });

  drawer.addEventListener('click', function (e) {
    if (e.target.closest('[data-cd-close]')) { e.preventDefault(); close(); return; }
    var minus = e.target.closest('[data-cd-minus]');
    var plus = e.target.closest('[data-cd-plus]');
    var remove = e.target.closest('[data-cd-remove]');
    if (minus) step(minus.getAttribute('data-key'), -1);
    else if (plus) step(plus.getAttribute('data-key'), 1);
    else if (remove) change(remove.getAttribute('data-key'), 0);
  });
  drawer.addEventListener('change', function (e) {
    var input = e.target.closest('[data-cd-qty-input]');
    if (input) { var v = parseInt(input.value, 10); if (isNaN(v) || v < 0) v = 0; change(input.getAttribute('data-key'), v); }
  });

  function step(key, d) {
    var input = drawer.querySelector('[data-cd-qty-input][data-key="' + esc(key) + '"]');
    var cur = input ? parseInt(input.value, 10) || 0 : 0;
    change(key, Math.max(0, cur + d));
  }

  function loading(on) { var l = drawer.querySelector('[data-cd-loading]'); if (l) l.classList.toggle('is-active', !!on); }

  function change(key, qty) {
    loading(true);
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty, sections: SECTION_ID, sections_url: window.location.pathname })
    }).then(function (r) { return r.json(); })
      .then(function (data) { render(data); })
      .catch(function () {}).finally(function () { loading(false); });
  }

  // Intercept add-to-cart forms
  qsa('form[action$="/cart/add"], form[action="/cart/add"]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = form.querySelector('[type="submit"]');
      if (btn) { btn.classList.add('is-loading'); btn.disabled = true; }
      var fd = new FormData(form);
      fd.append('sections', SECTION_ID);
      fetch('/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: fd })
        .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
        .then(function (res) { if (res.ok) return refresh().then(open); })
        .finally(function () { if (btn) { btn.classList.remove('is-loading'); btn.disabled = false; } });
    });
  });

  function render(data) {
    var html = data && data.sections && data.sections[SECTION_ID];
    if (html) apply(html); else refresh();
    if (data && typeof data.item_count === 'number') bubbles(data.item_count); else counts();
  }
  function refresh() {
    return fetch('/?sections=' + SECTION_ID).then(function (r) { return r.json(); })
      .then(function (data) { if (data && data[SECTION_ID]) apply(data[SECTION_ID]); return counts(); });
  }
  function apply(html) {
    var tmp = document.createElement('div'); tmp.innerHTML = html;
    var np = tmp.querySelector('.cd__panel'); var cp = drawer.querySelector('.cd__panel');
    if (np && cp) { cp.innerHTML = np.innerHTML; panel = cp; }
    counts();
  }
  function counts() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); })
      .then(function (c) { bubbles(c.item_count); return c; }).catch(function () {});
  }
  function bubbles(n) {
    qsa('[data-cart-count], .pave-header__cart-count').forEach(function (el) {
      el.textContent = n; if (n > 0) el.removeAttribute('hidden'); else el.setAttribute('hidden', '');
    });
  }
  function esc(s) { return (window.CSS && window.CSS.escape) ? window.CSS.escape(s) : String(s).replace(/["\\]/g, '\\$&'); }

  window.PavemomCart = { open: open, close: close, refresh: refresh };
})();
